import type { IconSvgObject } from './types';

const SquareXIcon: IconSvgObject = [
  ["path", { d: "M11.9922 21.5H11.9922H11.9922C16.4705 21.5 18.7097 21.5 20.1009 20.1088C21.4922 18.7175 21.4922 16.4783 21.4922 12V12V12C21.4922 7.52165 21.4922 5.28248 20.1009 3.89124C18.7097 2.5 16.4705 2.5 11.9922 2.5C7.51384 2.5 5.27467 2.5 3.88343 3.89124C2.49219 5.28249 2.49219 7.52166 2.49219 12C2.49219 16.4783 2.49219 18.7175 3.88343 20.1088C5.27467 21.5 7.51384 21.5 11.9922 21.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.9922 9L8.99219 14.9996M14.9922 15L8.99219 9.00039", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SquareXIcon;
